export default function FranklinTNMistakesSection() {
  const mistakes = [
    {
      icon: "ri-time-line",
      title: "Assuming the Nashville Agency Is Easy to Use",
      description: "The Atlanta Passport Agency at 801 Broadway is just 20 miles from Franklin, but public appointment availability is fiercely competitive. Many Williamson County residents assume they can walk in or quickly book an appointment — and discover slots are booked weeks out.",
    },
    {
      icon: "ri-camera-off-line",
      title: "Wrong Passport Photo",
      description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. Cool Springs and Brentwood travelers who skip photo verification can lose critical processing time. We provide exact specs so you get it right the first time.",
    },
    {
      icon: "ri-file-damage-line",
      title: "Incomplete or Mismatched Forms",
      description: "One missing signature, wrong date, or mismatched name between your passport application and flight booking, and your application gets sent back. Our document review catches these errors before submission — saving days or weeks you don't have before a board meeting.",
    },
    {
      icon: "ri-pen-nib-line",
      title: "Wrong Proof of Citizenship",
      description: "Not all birth certificates are accepted — some require a long-form version. Many Franklin-area residents relocating from other states bring the wrong document type. We tell you exactly which documents you need based on your situation.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Waiting Until the Week Before Travel",
      description: "Williamson County travelers — especially corporate executives — frequently delay passport renewal until a trip is imminent. Even expedited processing requires some lead time. Contact us as soon as you know you have upcoming international travel.",
    },
    {
      icon: "ri-map-pin-time-line",
      title: "Not Checking Passport Validity Requirements",
      description: "Many countries require six months of passport validity beyond your return date. A Franklin traveler with a passport expiring in four months may be turned away at the gate for a European or Latin American destination. Always check destination requirements when booking.",
    },
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Avoid Delays</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Application Mistakes Franklin, TN Travelers Make
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            These mistakes cause the most delays and rejections for Franklin and Williamson County travelers. Fast Passport Center reviews your documents before submission to catch these issues — so your corporate trip, family vacation, or international conference stays on schedule.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-[#F7F8FA] rounded-lg p-5 border border-gray-200 hover:border-[#F6C344] transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 flex-shrink-0">
                <i className={`${m.icon} text-red-400 text-lg`}></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-sm mb-1">{m.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-shield-check-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base">We check everything for you.</p>
            <p className="text-white/70 text-sm mt-1">
              Fast Passport Center reviews your documents before submission — so Williamson County travelers don't have to worry about these mistakes causing delays before their next international trip.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}